import { HeaderShell } from './HeaderShell'

export default function SiteHeader() {
  return (
    <>
      {/* Skip to content link (a11y) */}
      <a
        href="#main-content"
        className="skip-link"
      >
        Skip to main content
      </a>
      <HeaderShell />
    </>
  )
}
